import React, { useState } from 'react';

const Sidebar = ({ experiments, onExperimentClick, onAddExperiment, selectedExperiment }) => {
  const [hoveredExperiment, setHoveredExperiment] = useState(null);

  return (
    <div className="w-full lg:w-1/4 bg-white p-4 rounded-lg shadow-md mb-6 lg:mb-0">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">Esperimenti</h2>
        <button onClick={onAddExperiment} className="text-gray-800 hover:text-[#e06615]">
          <i className="fas fa-plus"></i> Aggiungi
        </button>
      </div>
      <ul>
        {experiments.map((experiment, index) => (
          <li
            key={index}
            className={`mb-2 p-5 rounded-xl cursor-pointer hover:bg-gray-100 ${selectedExperiment?.id===experiment?.id ? 'border-2 border-black' : 'border border-gray-200'}`}
            onMouseEnter={() => setHoveredExperiment(index)}
            onMouseLeave={() => setHoveredExperiment(null)}
            onClick={() => onExperimentClick(experiment)}
          >
            <div className="flex items-center">
              <h3 className="text-lg font-semibold text-gray-800">{experiment.titolo}</h3>
              {hoveredExperiment === index && (
                <i className="fas fa-pencil-alt text-gray-600 ml-2 hover:text-gray-800"></i>
              )}
            </div>
            <p className="text-gray-600 text-sm">{experiment.descrizione}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;